import { Collapse, Form } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import React from "react";

const { Panel } = Collapse;

const LeyendaModulosLimitarProyectos = () => {
  return (
    <Form.Item
      colon={false}
      label=" "
      wrapperCol={{ span: 14 }}
      style={{ marginBottom: 12 }}
    >
      <Collapse
        bordered={false}
        style={{ background: "#f5f7fa", borderRadius: 8 }}
      >
        <Panel
          key="1"
          header={
            <span style={{ fontSize: 13, color: "#595959" }}>
              <InfoCircleOutlined style={{ marginRight: 8, color: "#1890ff" }} />
              ¿En qué módulos aplica?
            </span>
          }
        >
          <p style={{ marginBottom: 6, fontSize: 13, color: "#595959" }}>
            Actualmente solo está disponible en los módulos de:
          </p>
          <ul style={{ marginBottom: 0, paddingLeft: 18, fontSize: 13, color: "#595959" }}>
            <li>Proveedores</li>
            <li>Ordenes de compra</li>
            <li>Proyectos</li>
          </ul>
        </Panel>
      </Collapse>
    </Form.Item>
  );
};

export default LeyendaModulosLimitarProyectos;
